//Custom ScrollIntoView function to put child element in center of the parent element.
type TAlign = 'both' | 'vertical' | 'horizontal'

type TScrollIntoViewProps = {
  child: Element
  parentParam?: Element
  align?: TAlign
}

type TCenter = {
  vertical: number
  horizontal: number
}

export const scrollIntoView = ({ child, parentParam, align = 'both' }: TScrollIntoViewProps) => {
  const parent = parentParam || document.getElementById('wrapper') || document.body

  const { top: parentTop, left: parentLeft, right: parentRight, bottom: parentBottom } = parent.getBoundingClientRect()
  const { top: childTop, left: childLeft, right: childRight, bottom: childBottom } = child.getBoundingClientRect()

  const parentCenter: TCenter = {
    vertical: (parentTop + parentBottom) / 2,
    horizontal: (parentLeft + parentRight) / 2,
  }
  const childCenter: TCenter = {
    vertical: (childTop + childBottom) / 2,
    horizontal: (childLeft + childRight) / 2,
  }

  if (align === 'both') {
    scrollTo(parent, +childCenter.horizontal - parentCenter.horizontal, 300, 'horizontal')
    scrollTo(parent, +childCenter.vertical - parentCenter.vertical, 300, 'vertical')
  } else scrollTo(parent, +childCenter[align] - parentCenter[align], 300, align)
}
function scrollTo(element: Element, to: number, duration: number, align?: TAlign) {
  const start = align === 'horizontal' ? element.scrollLeft : element.scrollTop
  const currentTime = 0
  const increment = 20

  const animateScroll = function (time: number) {
    const currentTime = time + increment

    const val = easeInOutQuad(currentTime, start, to, duration)
    if (align === 'horizontal') {
      element.scrollLeft = val
    } else element.scrollTop = val

    if (currentTime < duration) setTimeout(() => animateScroll(currentTime), increment)
  }

  animateScroll(currentTime)
}
// Function for smooth scroll animation with the time duration
function easeInOutQuad(time: number, startPos: number, endPos: number, duration: number) {
  const currentTime = time / (duration / 2)

  if (currentTime < 1) return (endPos / 2) * currentTime * currentTime + startPos

  const decTime = currentTime - 1
  return (-endPos / 2) * (decTime * (decTime - 2) - 1) + startPos
}
